import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../../utils/notificationService";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getDnhProductsByPartNumbers, getIngramPriceAvailability, getDistributorStock } from "../../../api/edi.api";
import {
  orderTerms,
  purchaseCompanies,
  purchaseOrdersStatuses,
  purchaseShippings
} from "../../../data";
import {
  addToArray,
  generateCustomID,
  getDocByKeyValue,
  saveData,
  uniqueID,
  uploadingImages,
} from "../../../firebase/utility";
import { getShippingIdentifier } from "../../../utils/shippingIdentifier";
const useUpdatePurchaseOrder = (props) => {
  const history = useHistory();
  const { state } = props.location;
  const { id } = useParams();
  const { obj, vendor, type } = state || {};
  const [loader, setLoader] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [orderData, setOrderData] = useState(null);
  console.log('orderData', orderData);
  const [billingData, setBillingData] = useState({});
  const [shippingData, setShippingData] = useState({});
  const [poDetails, setPoDetails] = useState([]);
  const [line_items, setLineItems] = useState(obj?.line_items ?? []);
  const [orderNotes, setOrderNotes] = useState(orderData?.orderNotes ?? []);
  const [subTotal, setSubTotal] = useState(orderData?.subTotal ?? obj?.subTotal ?? 0);
  const [total, setTotal] = useState(orderData?.total ?? state?.total ?? 0);
  const [vendorPoNumber, setVendorPoNumber] = useState(orderData?.vendorPoNumber ?? obj?.vendorPoNumber ?? '');
  const [new_line_items, setNewLineItems] = useState([]);
  const [dnhData, setDnhData] = useState([]);
  const [ingramData, setIngramData] = useState([]);
  const [distributorStockData, setDistributorStockData] = useState([]);
  const [distributorStockLoading, setDistributorStockLoading] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [purchaseOrderStatus, setPurchaseOrderStatus] = useState(
    purchaseOrdersStatuses.find((i) => i.value === (orderData?.purchaseOrderStatus ?? obj?.purchaseOrderStatus) || i.label === (orderData?.purchaseOrderStatus ?? obj?.purchaseOrderStatus))?.label ?? ""
  );
  const [poNumber, setPoNumber] = useState(obj?.po_no ?? "");
  const [terms, setTerms] = useState(
    orderTerms?.find((i) => i?.value === vendor?.billing?.[0]?.terms)?.value ?? ""
  );
  const [shipping, setShipping] = useState(
    purchaseShippings?.find((i) => i?.value === (orderData?.shippingVia ?? obj?.shippingVia))?.value ?? ""
  );
  const [company, setCompany] = useState(
    purchaseCompanies?.find((i) => i?.value === (orderData?.company ?? obj?.company))?.value ?? ((orderData?.company ?? obj?.company) || "Cheapest Option")
  );
  const [vendorInstructions, setVendorInstructions] = useState(
    obj?.vendorInstructions ?? ""
  );
  const [orderNote, setOrderNote] = useState(orderData?.orderNote ?? "");
  const [addressType, setAddressType] = useState(
    orderData?.addressType ?? obj?.addressType ?? "COMMERCIAL"
  );
  const [signatureRequired, setSignatureRequired] = useState(
    orderData?.signatureRequired ?? obj?.signatureRequired ?? ""
  );
  const [itemModal, setItemModal] = useState(false);
  const [totalTaxAmount, setTotalTaxAmount] = useState({
    tax: orderData?.totalTaxAmount?.tax ?? obj?.totalTaxAmount?.tax ?? 0,
    shipping: orderData?.totalTaxAmount?.shipping ?? obj?.totalTaxAmount?.shipping ?? 0,
  });
  const [shippingCheckboxes, setShippingCheckboxes] = useState({
    sms_disabled: orderData?.shippingCheckboxes?.sms_disabled ?? false,
    residiential: orderData?.shippingCheckboxes?.residiential ?? false,
    do_not_email: orderData?.shippingCheckboxes?.do_not_email ?? false,
    ship_partially: orderData?.shippingCheckboxes?.ship_partially ?? false,
  });
  const [freightBillingAccount, setFreightBillingAcc] = useState(orderData?.freightBillingAccount ?? "");
  const toggleItemModal = () => {
    setItemModal(!itemModal);
  };
  const calculateTotal = async () => {
    let calculate_total_amount =
      parseFloat(subTotal) + parseFloat(totalTaxAmount?.tax) + parseFloat(totalTaxAmount?.shipping);
    setTotal(calculate_total_amount);
  };
  const handleUpdate = async () => {
    // Validate PO quantity against parent Sales Order quantity
    if (soLineItems?.length > 0) {
      for (const item of line_items || []) {
        const orderedQty = parseInt(item?.quantity ?? 0);
        const soItem = soLineItems.find((soIt) =>
          (soIt.sku && item.sku && soIt.sku.toLowerCase() === item.sku.toLowerCase())
        );
        if (soItem && orderedQty > parseInt(soItem.quantity ?? 0)) {
          toast.error(
            `PO quantity (${orderedQty}) for "${item.sku || item.name || 'Item'}" cannot exceed Sales Order quantity (${soItem.quantity}).`
          );
          return;
        }
      }
    }

    setLoader(true);
    let x = { ...billingData, terms: terms };
    let finalLineItems;
    if (line_items?.length > 0) {
      let arr = await uploadingImages(
        line_items ?? [],
        "purchase_items_images"
      );
      finalLineItems = line_items?.map((item, index) => ({
        ...item,
        quantity: parseInt(item?.quantity ?? 0),
        image: { src: arr[index], id: uniqueID() },
      }));
    }
    let finalObj = {
      line_items: finalLineItems,
      vendor: x,
      shipping: shippingData,
      shippingCheckboxes,
      vendorInstructions: vendorInstructions,
      orderNote: orderNote,
      total: total,
      totalTaxAmount: totalTaxAmount,
      subTotal: subTotal,
      vendorId: vendor?._id || orderData?.vendorId || obj?.vendorId,
      vendorOrderId: vendor?.id ?? orderData?.vendorOrderId ?? obj?.vendorOrderId ?? "",
      vendorPoNumber: vendorPoNumber,
      po_no: poNumber || orderData?.po_no || obj?.po_no || "",
      company: company,
      shippingVia: shipping,
      id: obj?.id ?? orderData?.id ?? (await generateCustomID("PurchaseOrders", "id")),
      _id: obj?._id || orderData?._id || id,
      saleOrderId: obj?.saleOrderId ?? orderData?.saleOrderId ?? "",
      shippingIdentifier:
        orderData?.shippingIdentifier ||
        obj?.shippingIdentifier ||
        getShippingIdentifier({ ...orderData, ...obj, shipping: shippingData }),
      created_at: orderData?.created_at ?? obj?.created_at ?? Date.parse(new Date()),
      freightBillingAccount: freightBillingAccount ?? "",
      addressType: addressType || "COMMERCIAL",
      signatureRequired: signatureRequired || "",
      updated_by: {
        username: user?.username || "",
        email: user?.email || "",
        _id: user?._id || "",
        updated_at: Date.now()
      },
      created_by: orderData?.created_by ?? obj?.created_by ?? {}
    };
    saveData("PurchaseOrders", finalObj?._id || id, finalObj)
      .then((res) => {
        if (res) {
          toast.success("Purchase Order Updated Successfully !");
          createAdminNotification({
            title: "Purchase Order Updated",
            message: `Purchase Order #${poNumber || finalObj.po_no || finalObj.id} was updated by ${user?.username || "Admin"}`,
            category: "purchase_order",
            entityId: String(poNumber || finalObj.po_no || finalObj.id || id),
            targetUrl: `/admin/purchase-orders-details/${finalObj?._id || id}`,
            actor: user,
          }).catch(console.error);

          if (finalObj?.saleOrderId) {
            addToArray('Orders', finalObj.saleOrderId, 'logs', {
              createdAt: Date.parse(new Date()),
              createdBy: user,
              message: `Purchase order # ${poNumber || finalObj.po_no} was updated!`
            });
          }
          setLoader(false);
        } else {
          toast.error("Failed to update Purchase Order");
          setLoader(false);
        }
      })
      .catch((error) => {
        toast.error(error?.message || "Failed to update Purchase Order");
        setLoader(false);
      });
  };
  // USEEFFECT HOOKS ++++++++++++++++++++++++++++++++++++++++++++++++
  useEffect(() => {
    let subtotal = 0;
    line_items.forEach((item) => {
      const quantity = parseInt(item.quantity ?? 0);
      const price = parseFloat(item.price ?? 0);
      subtotal += quantity * price;
    });
    setSubTotal(subtotal?.toFixed(2));
    setTotal(subtotal?.toFixed(2));
  }, [line_items]);
  useEffect(() => {
    calculateTotal();
  }, [totalTaxAmount, line_items, subTotal]);
  useEffect(() => {
    if (state?._id) {
      getDocByKeyValue("PurchaseOrders", "saleOrderId", state?._id).then(
        (res) => {
          if (res && res.length > 0) {
            setPoDetails(res);
          }
        }
      );
    }
  }, [state?._id]);
  useEffect(() => {
    if (state) {
      setShippingData({
        company: obj?.shipping?.company ?? "",
        first_name: obj?.shipping?.first_name ?? "",
        last_name: obj?.shipping?.last_name ?? "",
        address_1: obj?.shipping?.address_1 ?? "",
        address_2: obj?.shipping?.address_2 ?? "",
        city: obj?.shipping?.city ?? "",
        state: obj?.shipping?.state ?? "",
        phone: obj?.shipping?.phone ?? "",
        postcode: obj?.shipping?.postcode ?? "",
        email: obj?.shipping?.email ?? "",
      });
      setBillingData({
        company: orderData?.vendor?.company ?? vendor?.billing?.[0]?.company ?? "",
        originalCompany: vendor?.billing?.[0]?.company ?? vendor?.company ?? vendor?.billing?.[0]?.company ?? "",
        first_name: orderData?.vendor?.first_name ?? vendor?.billing?.[0]?.first_name ?? "",
        last_name: orderData?.vendor?.last_name ?? vendor?.billing?.[0]?.last_name ?? "",
        address_1: orderData?.vendor?.address_1 ?? vendor?.billing?.[0]?.address_1 ?? "",
        address_2: orderData?.vendor?.address_2 ?? vendor?.billing?.[0]?.address_2 ?? "",
        city: orderData?.vendor?.city ?? vendor?.billing?.[0]?.city ?? "",
        state: orderData?.vendor?.state ?? vendor?.billing?.[0]?.state ?? "",
        phone: orderData?.vendor?.phone ?? vendor?.billing?.[0]?.phone ?? "",
        postcode: orderData?.vendor?.postcode ?? vendor?.billing?.[0]?.postcode ?? "",
        email: orderData?.vendor?.email ?? vendor?.billing?.[0]?.email ?? "",
        dba: vendor?.billing?.[0]?.dba ?? vendor?.dba ?? [],
        selectedDBA: orderData?.vendor?.selectedDBA ?? "",
      });
    }
  }, [vendor, obj]);

  useEffect(() => {
    if (!id) return;
    const unsubscribe = firebase
      .firestore()
      .collection("PurchaseOrders")
      .doc(id)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const currentOrderData = doc.data();
          setOrderData(currentOrderData);
          setLineItems(currentOrderData?.line_items ?? []);
          setOrderNotes(currentOrderData?.orderNotes ?? []);
          setSubTotal(currentOrderData?.subTotal ?? 0);
          setCompany(currentOrderData?.company || "Cheapest Option");
          setTotal(currentOrderData?.total);
          setTotalTaxAmount({
            tax: currentOrderData?.totalTaxAmount?.tax ?? 0,
            shipping: currentOrderData?.totalTaxAmount?.shipping ?? 0,
          });
          setShipping(
            purchaseShippings?.find(
              (i) => i?.value === (currentOrderData?.shippingVia ?? obj?.shippingVia)
            )?.value ?? (currentOrderData?.shippingVia || "")
          );
          setFreightBillingAcc(currentOrderData?.freightBillingAccount ?? "");
          if (currentOrderData?.vendorInstructions !== undefined) {
            setVendorInstructions(currentOrderData?.vendorInstructions || "");
          }
          if (currentOrderData?.orderNote !== undefined) {
            setOrderNote(currentOrderData?.orderNote || "");
          }
          if (currentOrderData?.vendorPoNumber !== undefined) {
            setVendorPoNumber(currentOrderData?.vendorPoNumber || "");
          }
          if (currentOrderData?.po_no !== undefined || currentOrderData?.id !== undefined) {
            setPoNumber(currentOrderData?.po_no || currentOrderData?.id || "");
          }
          if (currentOrderData?.addressType !== undefined) {
            setAddressType(currentOrderData?.addressType || "COMMERCIAL");
          }
          if (currentOrderData?.signatureRequired !== undefined) {
            setSignatureRequired(currentOrderData?.signatureRequired || "");
          }
          if (currentOrderData?.purchaseOrderStatus) {
            setPurchaseOrderStatus(
              purchaseOrdersStatuses.find(
                (i) => i.value === currentOrderData.purchaseOrderStatus || i.label === currentOrderData.purchaseOrderStatus
              )?.label ?? currentOrderData.purchaseOrderStatus
            );
          }
          if (currentOrderData?.shippingCheckboxes) {
            setShippingCheckboxes(currentOrderData.shippingCheckboxes);
          }
          if (currentOrderData?.vendor) {
            setBillingData({
              company: currentOrderData.vendor.company ?? "",
              originalCompany: currentOrderData.vendor.originalCompany ?? currentOrderData.vendor.company ?? "",
              first_name: currentOrderData.vendor.first_name ?? "",
              last_name: currentOrderData.vendor.last_name ?? "",
              address_1: currentOrderData.vendor.address_1 ?? "",
              address_2: currentOrderData.vendor.address_2 ?? "",
              city: currentOrderData.vendor.city ?? "",
              state: currentOrderData.vendor.state ?? "",
              phone: currentOrderData.vendor.phone ?? "",
              postcode: currentOrderData.vendor.postcode ?? "",
              email: currentOrderData.vendor.email ?? "",
              dba: currentOrderData.vendor.dba ?? [],
              selectedDBA: currentOrderData.vendor.selectedDBA ?? "",
            });
            if (currentOrderData.vendor.terms) {
              setTerms(currentOrderData.vendor.terms);
            }
          }
          if (currentOrderData?.shipping) {
            setShippingData(currentOrderData.shipping);
          }
        } else {
          getDocByKeyValue("PurchaseOrders", "_id", id).then((res) => {
            if (res && res.length > 0) {
              const currentOrderData = res[0];
              setOrderData(currentOrderData);
              setLineItems(currentOrderData?.line_items ?? []);
              setOrderNotes(currentOrderData?.orderNotes ?? []);
              setSubTotal(currentOrderData?.subTotal ?? 0);
              setCompany(currentOrderData?.company || "Cheapest Option");
              setTotal(currentOrderData?.total);
              setTotalTaxAmount({
                tax: currentOrderData?.totalTaxAmount?.tax ?? 0,
                shipping: currentOrderData?.totalTaxAmount?.shipping ?? 0,
              });
              setShipping(
                purchaseShippings?.find(
                  (i) => i?.value === (currentOrderData?.shippingVia ?? obj?.shippingVia)
                )?.value ?? (currentOrderData?.shippingVia || "")
              );
              setFreightBillingAcc(currentOrderData?.freightBillingAccount ?? "");
              if (currentOrderData?.vendorInstructions !== undefined) {
                setVendorInstructions(currentOrderData?.vendorInstructions || "");
              }
              if (currentOrderData?.orderNote !== undefined) {
                setOrderNote(currentOrderData?.orderNote || "");
              }
              if (currentOrderData?.vendorPoNumber !== undefined) {
                setVendorPoNumber(currentOrderData?.vendorPoNumber || "");
              }
              if (currentOrderData?.po_no !== undefined || currentOrderData?.id !== undefined) {
                setPoNumber(currentOrderData?.po_no || currentOrderData?.id || "");
              }
              if (currentOrderData?.shippingCheckboxes) {
                setShippingCheckboxes(currentOrderData.shippingCheckboxes);
              }
              if (currentOrderData?.vendor) {
                setBillingData(currentOrderData.vendor);
                if (currentOrderData.vendor.terms) {
                  setTerms(currentOrderData.vendor.terms);
                }
              }
              if (currentOrderData?.shipping) {
                setShippingData(currentOrderData.shipping);
              }
            }
          });
        }
      });
    return () => unsubscribe();
  }, [id]);
  useEffect(() => {
    const currentLineItems = line_items?.length > 0 ? line_items : (orderData?.line_items || []);
    if (currentLineItems?.length > 0) {
      const skus = currentLineItems
        .map((item) => item.sku || item.parts)
        .filter(Boolean);

      if (skus.length > 0) {
        setDistributorStockLoading(true);
        getDistributorStock(skus, (response) => {
          setDistributorStockLoading(false);
          if (response?.status === 200 && response?.data?.data) {
            setDistributorStockData(response.data.data);
          }
        });
      }
    }
  }, [orderData, line_items]);
  const [saleOrderData, setSaleOrderData] = useState(null);

  useEffect(() => {
    const soId = orderData?.saleOrderId || obj?.saleOrderId || state?.saleOrderId;
    if (soId) {
      getDocByKeyValue("Orders", "_id", soId).then((res) => {
        if (res && res.length > 0) {
          setSaleOrderData(res[0]);
        } else {
          getDocByKeyValue("Orders", "id", soId).then((r2) => {
            if (r2 && r2.length > 0) {
              setSaleOrderData(r2[0]);
            }
          });
        }
      });
    }
  }, [orderData?.saleOrderId, obj?.saleOrderId, state?.saleOrderId]);

  const soLineItems = saleOrderData?.line_items || [];

  return {
    state,
    vendor,
    obj,
    line_items,
    setLineItems,
    orderNotes,
    setOrderNotes,
    subTotal,
    total,
    poNumber,
    setPoNumber,
    terms,
    setTerms,
    shipping,
    setShipping,
    company,
    setCompany,
    vendorInstructions,
    setVendorInstructions,
    orderNote,
    setOrderNote,
    totalTaxAmount,
    setTotalTaxAmount,
    shippingCheckboxes,
    setShippingCheckboxes,
    itemModal,
    toggleItemModal,
    handleUpdate,
    poDetails,
    shippingData,
    setShippingData,
    billingData,
    setBillingData,
    history,
    type,
    vendorPoNumber, setVendorPoNumber,
    loader, purchaseOrderStatus, setPurchaseOrderStatus, orderData, freightBillingAccount, setFreightBillingAcc, setOrderData, new_line_items, setNewLineItems,
    dnhData, setDnhData, ingramData, setIngramData, distributorStockData, distributorStockLoading, pageLoader, soLineItems,
    addressType, setAddressType, signatureRequired, setSignatureRequired,
  };
};
export default useUpdatePurchaseOrder;
